import { H1, H4 } from '../../../styles/FontStyles';
import { Main, Section2Wrapper } from '../Home.styled';

import { colors, Div, Img } from 'styles';
import image1 from '../../../assets/images/sec2Img1.png';
import image2 from '../../../assets/images/sec2Img2.png';
import image3 from '../../../assets/images/sec2Img3.png';
import { MarqueeComponent } from './section6';
import { AnimatedDiv } from 'components/Animation/Animation';

export const Section2 = () => {
  return (
    <Section2Wrapper id='section2'>
      <Main>
        <AnimatedDiv>
          <H1 centerSM mb='30' mt='30' color={colors.white}>
            Ignite Innovation <br /> Through Unity
          </H1>
          <H4 centerSM mb='60' color={colors.white}>
            Empowering people to build, evolve, and lead the future together
          </H4>
        </AnimatedDiv>

        <AnimatedDiv $desktop $flex $center $relative $mt='160px' $mb='100px'>
          <Div $width='20%' $relative>
            <Img
              src={image1}
              alt='Travelution'
              $width='150%'
              style={{
                position: 'relative',
                left: '0%',
                top: '-100px',

                zIndex: 0,
              }}
            />
          </Div>
          <Div $width='60%' $relative>
            <Img
              src={image2}
              alt='Travelution'
              $width='100%'
              style={{ position: 'relative', zIndex: 3 }}
            />
          </Div>
          <Div $width='20%' $relative>
            <Img
              src={image3}
              alt='Travelution'
              $width='150%'
              style={{
                position: 'relative',
                right: '50%',
                top: '100px',
              }}
            />
          </Div>
        </AnimatedDiv>
        <AnimatedDiv $mobile $flex $column $gap='20px'>
          <Img
            src={image1}
            alt='Travelution'
            $width='100%'
            $widthSM='100%'
            style={{}}
          />
          <Img src={image2} alt='Travelution' $width='100%' />
          <Img src={image3} alt='Travelution' $width='100%' />
        </AnimatedDiv>
      </Main>
      <MarqueeComponent />
    </Section2Wrapper>
  );
};
